import { ExternalService } from "../services/ExternalService";

/**
 * Polls S3 for file list changes after an upload.
 * Keeps fetching until the file count differs from `previousCount`,
 * then resolves with the new file list.
 *
 * @param {string} fileType - The file type parameter for reviewFiles
 * @param {string} path - The path parameter for reviewFiles
 * @param {number} previousCount - The file count before the upload
 * @param {object} [options]
 * @param {number} [options.interval=1500] - Polling interval in ms
 * @param {number} [options.maxAttempts=10] - Max number of poll attempts before giving up
 * @returns {Promise<Array>} - The updated file list (filtered, excluding response.html)
 */
export async function pollForFileChange(
  fileType,
  path,
  previousCount,
  { interval = 1500, maxAttempts = 10 } = {}
) {
  for (let attempt = 0; attempt < maxAttempts; attempt++) {
    await new Promise((resolve) => setTimeout(resolve, interval));

    const paths = await ExternalService.reviewFiles(fileType, path);
    const filtered = paths.filter((file) => file.file_name !== "response.html");

    if (filtered.length !== previousCount) {
      return filtered;
    }
  }

  // Give up after max attempts — return whatever we last fetched
  const paths = await ExternalService.reviewFiles(fileType, path);
  return paths.filter((file) => file.file_name !== "response.html");
}
